import { HistoryEmptyOrError } from 'src/app/components/HistoryErrorState';
import { selectHistoryError } from 'src/features/historyError';
import {
  Box,
  Button,
  makeStyles,
  TextField,
  withStyles,
  SvgIcon,
  InputAdornment
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Pagination from '@material-ui/lab/Pagination';
import React from 'react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import {
  getLicensePlateQc31,
  resetListLicense
} from '../../../../features/reportBgtQC31Slice';
import {
  reportActivitySummary,
  exportActivitySummaryExcel,
  resetDataScreen
} from 'src/features/reportDNSlice';
import { Chip } from '@material-ui/core';
import DateTimeReport from 'src/app/components/input/DateTimeReport';
import { TAT_CA_DON_VI } from '../../../constant/reportFilters';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#F5FAFF',
    color: '#0C1132',
    border: '1px solid #E5E5E8',
    whiteSpace: 'nowrap',
    padding: '12px 16px',
    textAlign: 'center'
  },
  body: {
    fontSize: 14,
    border: '1px solid #E5E5E8',
    color: '#0C1132',
    whiteSpace: 'nowrap',
    padding: '8px 16px',
    textAlign: 'center'
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'white'
    }
  }
}))(TableRow);

const headCells = [
  { id: 'vehicleTypeTitle', label: 'Loại phương tiện' },
  { id: 'licensePlate', label: 'Biển số' },
  { id: 'date', label: 'Ngày tháng' },
  { id: 'startTime', label: 'Giờ đi' },
  { id: 'endTime', label: 'Giờ đến' },
  { id: 'distanceGPS', label: 'Km GPS' },
  { id: 'distanceMechanical', label: 'Km cơ' },
  { id: 'totalDriveTime', label: 'TG lái xe' },
  { id: 'totalStopDuration', label: 'TG dừng đỗ' },
  { id: 'driveOver4h', label: 'VP LX liên tục (lần)' },
  { id: 'countTotalOverspeed', label: 'VP quá tốc độ (lần)' },
  { id: 'stopTimes', label: 'Số lần dừng đỗ' },
  { id: 'maxSpeed', label: 'Tốc độ cực đại' },
  { id: 'averageSpeed', label: 'Tốc độ trung bình' },
  { id: 'signalLostTime', label: 'TG mất tín hiệu' }
];

const EnhancedTableHead = props => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell>STT</StyledTableCell>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              style={{ justifyContent: 'center', width: '100%', display: 'flex', flexDirection: 'row' }}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const ActivitySummary = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const historyError = useSelector(
    selectHistoryError('reportDNSlice', 'reportActivitySummary')
  );
  const [agencyError, setAgencyError] = useState(false);
  const [licensePlateError, setLicensePlateError] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('date');

  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isUser = useSelector(state => state.authSlice.isUser);
  const isDriver = useSelector(state => state.authSlice.isDriver);
  const licensePlateQc = useSelector(state => state.reportSlice.licensePlateQc);
  const listUserQC31 = useSelector(state => state.reportSlice.listUserQC31);
  const activitySummaryData = useSelector(
    state => state.reportDNSlice.activitySummaryData
  );
  const totalSummary = useSelector(state => state.reportDNSlice.totalSummary);
  const isExporting = useSelector(state => state.reportDNSlice.isExporting);
  const isLoading = useSelector(state => state.reportDNSlice.isLoading);
  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const userId = useSelector(state => state.authSlice.userId);
  const driverId = useSelector(state => state.authSlice.driverId);

  //should rename agencyId to userId, but take too much timeee ...
  const [searchObject, setSearchObject] = useState({
    licensePlates: [],
    agencyId: 0,
    firstTime: moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }),
    lastTime: moment().set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    }),
    page: 1,
    pageSize: 10
  });

  // Mục "Tất cả đơn vị" chỉ có nghĩa với admin — người dùng thường chỉ thấy đúng đơn vị của mình.
  // Sentinel mang chính id người đang đăng nhập: report API khoanh vùng theo user.id, và với admin
  // id đó phân giải ra toàn bộ xe của hệ thống. Ô biển số bên cạnh vốn đã có "Chọn tất cả".
  const listUser = (userId || driverId)
    ? [dataLogin]
    : isAdmin && listUserQC31 && listUserQC31.length
      ? [{ id: dataLogin?.id, full_name: TAT_CA_DON_VI }, ...listUserQC31]
      : listUserQC31;
  //should rename agencyId to userId, but take too much timeee ...
  const endUserValue = listUser?.find(
    item => item.id === searchObject.agencyId
  );

  // Prepare license plate options with "Select All" option
  const licensePlateOptions = ['Chọn tất cả', ...(licensePlateQc || [])];

  // Check if all license plates are selected
  const allSelected =
    licensePlateQc &&
    licensePlateQc.length > 0 &&
    searchObject.licensePlates &&
    searchObject.licensePlates.length === licensePlateQc.length;

  // Handle select all / deselect all
  const handleSelectAll = () => {
    if (allSelected) {
      // Deselect all
      changeSearchCondition('licensePlates', []);
    } else {
      // Select all
      changeSearchCondition('licensePlates', licensePlateQc || []);
    }
  };

  // Custom onChange to handle "Select All" option
  const handleLicensePlateChange = (e, value) => {
    const hasSelectAll = value.includes('Chọn tất cả');

    if (hasSelectAll) {
      // If currently all are selected, clicking "Select All" will deselect all
      if (allSelected) {
        changeSearchCondition('licensePlates', []);
        return;
      } else {
        // Select all license plates (excluding "Chọn tất cả")
        changeSearchCondition('licensePlates', licensePlateQc || []);
        return;
      }
    }

    changeSearchCondition('licensePlates', value);
  };

  useEffect(() => {
    return () => {
      dispatch(resetDataScreen());
    };
  }, []);

  // Auto-fill agency and fetch license plates for end user / driver
  useEffect(() => {
    if ((isUser || isDriver) && dataLogin?.id) {
      setSearchObject(prev => ({
        ...prev,
        agencyId: dataLogin.id
      }));
      dispatch(getLicensePlateQc31({ id: dataLogin.id, business_number: 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUser, isDriver, dataLogin]);

  const changeSearchCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    if (name === 'licensePlates' && value.length > 0) {
      setLicensePlateError(false);
    }
    if (name === 'agencyId') {
      currentSearchObject.agencyId = value.id;
      currentSearchObject.licensePlates = [];
      dispatch(getLicensePlateQc31({ id: value.id, business_number: 1 }));
    }
    setSearchObject(currentSearchObject);
  };

  const changeDateCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    setSearchObject(currentSearchObject);
  };

  const handleClearAgency = () => {
    setSearchObject({
      ...searchObject,
      agencyId: 0,
      licensePlates: []
    });
    dispatch(resetListLicense());
  };

  const searchFunction = () => {
    if (!searchObject.licensePlates?.length) {
      setLicensePlateError(true);
      return;
    }

    setLicensePlateError(false);
    let currentSearchObject = { ...searchObject };
    currentSearchObject.page = 1;
    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    currentSearchObject.agencyId = currentSearchObject.agencyId
      ? currentSearchObject.agencyId
      : 123456789;
    dispatch(reportActivitySummary(currentSearchObject));

    // Update local state to reset to page 1
    setSearchObject(prev => ({
      ...prev,
      page: 1
    }));
  };

  const handlePageChange = pageNumber => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject.page = pageNumber;
    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    currentSearchObject.agencyId = currentSearchObject.agencyId
      ? currentSearchObject.agencyId
      : 123456789;
    dispatch(reportActivitySummary(currentSearchObject));

    // Update local state to reflect the page change
    setSearchObject(prev => ({
      ...prev,
      page: pageNumber
    }));
  };

  const downloadFile = () => {
    const params = {
      agencyId: searchObject.agencyId,
      groupID: searchObject.groupID,
      licensePlates: searchObject.licensePlates || [],
      firstTime: searchObject.firstTime
        ? moment(searchObject.firstTime).unix()
        : '',
      lastTime: searchObject.lastTime
        ? moment(searchObject.lastTime).unix()
        : ''
    };

    dispatch(exportActivitySummaryExcel(params))
      .unwrap()
      .then(() => {})
      .catch(error => {});
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // Calculate total pages
  const totalPages = Math.ceil(totalSummary / searchObject.pageSize) || 1;

  // Sort data
  const sortedData = React.useMemo(() => {
    if (!activitySummaryData || activitySummaryData.length === 0) return [];
    return stableSort(activitySummaryData, getComparator(order, orderBy));
  }, [activitySummaryData, order, orderBy]);

  return (
    <Box className={classes.contentContainer}>
      <div className={classes.titleHeader}>Báo cáo tổng hợp hoạt động</div>
      <div className={classes.searchContainer}>
        <div className={classes.searchRow}>
          <div className={classes.searchItem}>
            <div className={classes.label}>Từ ngày</div>
            <div>
              <DateTimeReport
                className={classes.searchComponent}
                dateTime={searchObject.firstTime}
                onChange={e => changeDateCondition('firstTime', e)}
                format="DD/MM/YYYY HH:mm:ss"
                showTime={{ format: 'HH:mm:ss' }}
              />
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đến ngày</div>
            <div>
              <DateTimeReport
                className={classes.searchComponent}
                dateTime={searchObject.lastTime}
                onChange={e => changeDateCondition('lastTime', e)}
                format="DD/MM/YYYY HH:mm:ss"
                showTime={{ format: 'HH:mm:ss' }}
              />
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đơn vị kinh doanh vận tải</div>
            <Autocomplete
              freeSolo
              forcePopupIcon
              id="free-solo-2-demo"
              size="small"
              disableClearable
              disabled={isUser || isDriver}
              options={listUser || []}
              getOptionLabel={option => option?.full_name}
              value={endUserValue || ''}
              onChange={(e, value) => {
                setAgencyError(false);
                changeSearchCondition('agencyId', value);
              }}
              classes={{ option: classes.option }}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponent}
                  error={agencyError}
                  helperText={
                    agencyError
                      ? 'Vui lòng chọn đơn vị kinh doanh vận tải trước'
                      : ''
                  }
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '16px',
                      padding: 0,
                      paddingLeft: 8
                    },
                    endAdornment: (
                      <>
                        {Number(searchObject.agencyId) > 0 && isAdmin && (
                          <InputAdornment
                            position="end"
                            style={{ cursor: 'pointer', paddingRight: '38px' }}
                            onClick={handleClearAgency}
                          >
                            <SvgIcon fontSize="small" color="action">
                              <ClearIcon />
                            </SvgIcon>
                          </InputAdornment>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    )
                  }}
                  variant="outlined"
                />
              )}
            />
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Biển số</div>
            <Autocomplete
              multiple
              id="license-plates-multi-select"
              size="small"
              options={licensePlateOptions || []}
              value={searchObject.licensePlates || []}
              onChange={handleLicensePlateChange}
              disableCloseOnSelect
              classes={{ option: classes.option }}
              getOptionLabel={option => option}
              renderOption={(option, { selected }) => {
                const isSelectAll = option === 'Chọn tất cả';
                return (
                  <div
                    className={classes.optionItem}
                    onClick={isSelectAll ? handleSelectAll : undefined}
                    style={
                      isSelectAll
                        ? {
                            cursor: 'pointer',
                            fontWeight: 600,
                            color: '#1976d2'
                          }
                        : {}
                    }
                  >
                    <div className={classes.checkboxWrapper}>
                      <input
                        type="checkbox"
                        checked={isSelectAll ? allSelected : selected}
                        className={classes.checkbox}
                        readOnly
                      />
                      <span className={classes.optionText}>{option}</span>
                    </div>
                  </div>
                );
              }}
              renderTags={(value, getTagProps) => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    maxWidth: '100%',
                    maxHeight: '32px'
                  }}
                >
                  {value
                    .filter(option => option !== 'Chọn tất cả')
                    .map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        size="small"
                        {...getTagProps({ index })}
                        className={classes.chip}
                      />
                    ))}
                </div>
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponentMulti}
                  error={licensePlateError}
                  helperText={
                    licensePlateError ? 'Vui lòng chọn ít nhất một biển số xe' : ''
                  }
                  placeholder={
                    (searchObject.licensePlates || []).filter(
                      option => option !== 'Chọn tất cả'
                    ).length === 0
                      ? 'Tất cả biển số'
                      : ''
                  }
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      height: '32px',
                      fontSize: '14px',
                      padding: '0px 8px'
                    }
                  }}
                  variant="outlined"
                />
              )}
            />
          </div>

          <div className={classes.btnSearch}>
            <Button
              type="button"
              variant="contained"
              className={classes.btnStyle}
              onClick={() => searchFunction()}
            >
              Tìm kiếm
            </Button>
          </div>
        </div>
      </div>

      <div className={classes.actionHead}>
        <img
          alt="print image"
          className={classes.image}
          src="/static/images/print.svg"
          // onClick={() => downloadFile()}
        />

        <img
          alt="Excel image"
          className={classes.image}
          src="/static/images/Excel.svg"
          onClick={() => !isExporting && downloadFile()}
          style={{
            opacity: isExporting ? 0.5 : 1,
            cursor: isExporting ? 'not-allowed' : 'pointer'
          }}
        />
        {isExporting && (
          <CircularProgress size={24} className={classes.loadingIcon} />
        )}
      </div>

      <div className={classes.dataTable}>
        <TableContainer className={classes.tableContainer}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
            stickyHeader
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {sortedData &&
                sortedData.length > 0 &&
                sortedData.map((row, index) => {
                  return (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.name}
                    >
                      <StyledTableCell>
                        {(searchObject.page - 1) * searchObject.pageSize +
                          index +
                          1}
                      </StyledTableCell>
                      <StyledTableCell>{row.vehicleTypeTitle}</StyledTableCell>
                      <StyledTableCell>{row.licensePlate}</StyledTableCell>
                      <StyledTableCell>
                        {moment(row.date).format('DD/MM/YYYY')}
                      </StyledTableCell>
                      <StyledTableCell>{row.startTime}</StyledTableCell>
                      <StyledTableCell>{row.endTime}</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'right' }}>{row.distanceGPS}</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'right' }}>
                        {row.distanceMechanical}
                      </StyledTableCell>
                      <StyledTableCell>{row.totalDriveTime}</StyledTableCell>
                      <StyledTableCell>{row.totalStopDuration}</StyledTableCell>
                      <StyledTableCell>{row.driveOver4h}</StyledTableCell>
                      <StyledTableCell>
                        {row.countTotalOverspeed}
                      </StyledTableCell>
                      <StyledTableCell>{row.stopTimes}</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'right' }}>{row.maxSpeed}</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'right' }}>{row.averageSpeed}</StyledTableCell>
                      <StyledTableCell>{row.signalLostTime}</StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        {!sortedData || sortedData.length < 1 ? (
          <HistoryEmptyOrError
            error={historyError}
            onRetry={() => dispatch(reportActivitySummary(historyError.arg))}
            emptyClassName={classes.bottomTableError}
          />
        ) : null}

        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        {sortedData && sortedData.length > 0 && (
          <div className={classes.pagination}>
            <Pagination
              count={totalPages}
              page={searchObject.page}
              onChange={(_, value) => handlePageChange(value)}
              color="primary"
              shape="rounded"
              showFirstButton
              showLastButton
              siblingCount={2}
              boundaryCount={1}
              classes={{
                root: classes.paginationRoot
              }}
            />
          </div>
        )}
      </div>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    backgroundColor: 'white',
    flexDirection: 'column'
  },
  titleHeader: {
    width: '100%',
    height: '36px',
    color: '#0C1132',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: '16px',
    fontSize: '20px'
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px'
  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    marginBottom: '20px',
    marginLeft: '5px',
    gap: '12px'
  },
  searchItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 0
  },
  label: {
    marginRight: '20px',
    marginBottom: '12px',
    fontSize: '14px',
    color: '#858C93'
  },
  searchComponent: {
    width: '280px',
    height: '38px',
    '& .MuiOutlinedInput-root': {
      height: '38px',
      '& fieldset': {
        top: 0
      }
    }
  },
  searchComponentMulti: {
    width: '280px',
    maxWidth: '280px',
    position: 'relative',
    '& .MuiOutlinedInput-root': {
      flexWrap: 'nowrap',
      overflow: 'hidden',
      minHeight: '38px',
      maxHeight: '38px',
      paddingTop: '4px',
      paddingBottom: '4px',
      backgroundColor: '#fafafa',
      '& fieldset': {
        top: 0,
        borderRadius: '4px'
      }
    },
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
      padding: '2px 4px',
      overflow: 'hidden'
    },
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      top: '38px',
      left: 0,
      marginLeft: '12px',
      whiteSpace: 'nowrap'
    }
  },
  timeComponent: {
    marginRight: '4px',
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '80px'
    }
  },
  dateComponent: {
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '260px'
    }
  },
  btnSearch: {
    width: '150px',
    height: '40px',
    marginLeft: '0'
  },
  btnDownload: {
    width: '100px',
    marginLeft: 'auto'
  },
  dataTable: {
    width: '100%',
    marginLeft: '20px',
    marginBottom: '30px'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  },
  wrapMenu: {
    marginTop: '30px',
    marginRight: '100px',
    marginLeft: '30px'
  },
  title: {
    color: '#3f51b5',
    cursor: 'pointer'
  },
  menuItem: {
    listStyleType: 'none',
    margin: 0,
    padding: 0
  },
  item: {
    paddingTop: '30px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '500',

    '&:hover': {
      color: '#3f51b5',
      borderBottom: '1px solid #3f51b5',
      width: 'max-content'
    }
  },
  table: {
    minWidth: 2800
  },
 tableContainer: {
    maxWidth: 'calc(100vw - 100px)',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#e4e4e4',
      borderRadius: '6px',
      '&:hover': {
        background: '#b8b8b8'
      }
    }
  },
  btnStyle: {
    padding: '10px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    width: '180px',
    height: '40px'
  },
  pagination: {
    width: '95%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: '64px',
    marginTop: '20px',
    gap: '8px'
  },
  paginationRoot: {
    '& .MuiPaginationItem-root': {
      fontSize: '14px',
      fontWeight: '500'
    },
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: 'white !important',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: `${theme.palette.primary.dark} !important`
      }
    }
  },
  actionHead: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    backgroundColor: 'white',
    marginBottom: '5px'
  },
  bottomTableError: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: '10px'
  },
  image: {
    marginRight: '10px'
  },
  loadingIcon: {
    position: 'absolute',
    right: '30px',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  option: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center'
  },
  optionItem: {
    width: '100%',
    padding: '8px 12px',
    borderBottom: '1px solid #f0f0f0',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  checkbox: {
    width: '18px',
    height: '18px',
    marginRight: '12px',
    cursor: 'pointer',
    accentColor: '#1976d2'
  },
  optionText: {
    fontSize: '14px',
    color: '#333'
  },
  chip: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    fontWeight: 500,
    borderRadius: '16px',
    margin: '4px 6px 4px 0',
    fontSize: '13px',
    height: '28px',
    '&:hover': {
      backgroundColor: '#bbdefb'
    },
    '& .MuiChip-deleteIcon': {
      color: '#1976d2',
      fontSize: '18px',
      '&:hover': {
        color: '#d32f2f'
      }
    }
  },
  deleteIcon: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1976d2',
    '&:hover': {
      color: '#d32f2f'
    }
  },
  // Responsive styles
  '@media (max-width: 1400px)': {
    searchComponent: {
      width: '240px'
    },
    searchComponentMulti: {
      width: '240px',
      maxWidth: '240px'
    }
  },
  '@media (max-width: 1200px)': {
    searchComponent: {
      width: '220px'
    },
    searchComponentMulti: {
      width: '220px',
      maxWidth: '220px'
    },
    btnSearch: {
      width: '120px'
    }
  },
  '@media (max-width: 992px)': {
    searchRow: {
      gap: '8px',
      marginRight: '16px'
    },
    searchItem: {
      minWidth: '45%'
    }
  }
}));

export default ActivitySummary;
